const AccessTokenName =
  process.env.REACT_ENV_ACCESS_TOKEN_NAME ?? "JWT_AccessToken";
const RefreshTokenName =
  process.env.REACT_ENV_REFRESH_TOKEN_NAME ?? "JWT_RefreshToken";
const CSRFTokenName = process.env.REACT_ENV_CSRF_TOKEN_NAME ?? "csrftoken";

// -----------------------------------------------------------------------------

export function getAccessToken(): string {
  return getCookie(AccessTokenName);
}

export function getRefreshToken(): string {
  return getCookie(RefreshTokenName);
}

export function getCSRFToken(): string {
  return getCookie(CSRFTokenName);
}

export function clearAccessTokens() {
  setCookie(AccessTokenName, "", window.location.host, "");
  setCookie(AccessTokenName, "", ".app.threatkey.com", "");
  setCookie(AccessTokenName, "", ".threatkey.com", "");
  setCookie(RefreshTokenName, "", window.location.host, "");
  setCookie(RefreshTokenName, "", ".app.threatkey.com", "");
  setCookie(RefreshTokenName, "", ".threatkey.com", "");
}

export function setAccessTokens(token: string, refreshToken: string): void {
  setCookie(AccessTokenName, token);
  setCookie(RefreshTokenName, refreshToken);
}

// -----------------------------------------------------------------------------

function getCookie(name: string): string {
  const cookieSearch = `${name}=`;
  function outUndesiredTokens(cookie: string): boolean {
    return cookie.trim().startsWith(cookieSearch);
  }

  //
  const cookie =
    (document.cookie ?? "").split(";").filter(outUndesiredTokens).pop() ?? "";

  //
  return decodeURIComponent(cookie.substring(cookieSearch.length + 1));
}

function setCookie(
  name: string,
  value: string = "",
  expires: string = "",
  domain: string = window.location.host,
  path: string = "/"
) {
  document.cookie = `${name}=${value}; expires=${expires}, domain=${domain}; path=${path}`;
}
